import type { AppRouteRecordRaw } from "@/types/router";
import { LAYOUT } from "@/router/constants";

const report: AppRouteRecordRaw = {
  path: "/report",
  name: "Report",
  redirect: "/report/category",
  component: LAYOUT,
  meta: {
    title: "价格提报",
  },

  children: [
    {
      path: "category",
      name: "AllianceReport",
      component: () => import("@/views/alliance/report/index.vue"),
      meta: {
        title: "价格报告",
      },
    },
    {
      path: "batch",
      name: "AllianceBatchReport",
      component: () => import("@/views/alliance/batch-report/index.vue"),
      meta: {
        title: "商品文件提报",
      },
    },
  ],
};

export default report;
